module.exports = __webpack_public_path__ + "img/legal-icon.39c90753.svg";